import script from "./third_party_cmp.vue?vue&type=script&setup=true&lang=js"
export * from "./third_party_cmp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__